import command_type_summary from './command_type_summary.json'
import deck_configuration from './deck_configuration.json'
import protocol_command_text from './protocol_command_text.json'

export const shared_en_resources = {
  command_type_summary,
  deck_configuration,
  protocol_command_text,
}
